<form  autocomplete="off" [formGroup]="searchForm" (keyup.enter)="searchIndividual()">
    <ul *ngIf="showSearchCriteriaCheckboxes" class="search__criteria">
        <li>
            <label class="mvd_label--inline">
                <input type="checkbox" formControlName="exactSearch" /> Exact Match
            </label>
        </li>
        <li>
            <label class="mvd_label--inline disabled">
                <input type="checkbox" disabled /> Extended
            </label>
        </li>
        <li>
            <label class="mvd_label--inline disabled">
                <input type="checkbox" disabled checked /> Show Image
            </label>
        </li>
    </ul>
    <p-panel #toggleablePanel [toggleable]="true" [collapsed]="!showSearchCriteria" (onAfterToggle)="showSearchCriteria = !$event.collapsed">
        <ng-template pTemplate="header">Search Criteria</ng-template>
        <fieldset>
            <div class="row">
                <div class="col-sm-5 col-md-4 col-lg-3 mvd_form-group">
                    <label>ID Type</label>
                    <select id="customerIdentificationTypeInput" class="mvd_form-control" formControlName="customerIdentificationTypeId" (change)="customerIdentificationTypeChange($event)">
                        <option [ngValue]="null">- Select -</option>
                        <option *ngFor="let identificationType of customerIdentificationTypes" [ngValue]="identificationType.id">{{ identificationType.displayValue }}</option>
                    </select>
                    <div class="alert alert-required" *ngIf="searchForm.dirty && searchForm.hasError('idTypeRequired')">Customer ID Type is required</div>
                </div>
                <div class="col-sm-5 col-md-4 col-lg-3 mvd_form-group">
                    <label class="required--multi" title="~ At least one is required" for="customerIdentificationValueInput">{{ customerIdentificationType() }}</label>
                    <ng-container *ngIf="identificationTypes.SSN.id === searchForm.value.customerIdentificationTypeId">
                        <ng-container *ngIf="maskSSN">
                            <input *ngIf="!searchForm.value.customerIdentificationValue || searchForm.value.customerIdentificationValue.length !== 9"
                                   id="customerIdentificationValueInput" class="mvd_form-control" type="text" #customerIdentificationValue
                                   formControlName="customerIdentificationValue" trim="blur" />
                            <input *ngIf="searchForm.value.customerIdentificationValue && searchForm.value.customerIdentificationValue.length === 9"
                                   class="mvd_form-control" type="text" [disabled]="true" [value]="'***-**-' + searchForm.value.customerIdentificationValue.substring(5,9)" />
                        </ng-container>
                        <input *ngIf="!maskSSN" id="customerIdentificationValueInput" class="mvd_form-control" type="text" #customerIdentificationValue
                               formControlName="customerIdentificationValue" trim="blur" />
                    </ng-container>
                    <input id="customerIdentificationValueInput" class="mvd_form-control" type="text" #customerIdentificationValue
                           formControlName="customerIdentificationValue" trim="blur"
                           *ngIf="identificationTypes.SSN.id !== searchForm.value.customerIdentificationTypeId" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.controls['customerIdentificationValue'].hasError('maxlength')">
                            {{ customerIdentificationType() }} has a maximum length of {{ searchForm.controls['customerIdentificationValue'].errors.maxlength.requiredLength }} characters
                        </div>
                        <div class="mvd_alert__rule" *ngIf="(searchForm.controls['lastName'].touched || searchForm.controls['customerIdentificationValue'].touched) && searchForm.hasError('lastNameOrIdNumberRequired')">
                            {{ customerIdentificationType() }} or Last Name is required
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label for="firstNameInput">First Name</label>
                    <input id="firstNameInput" class="mvd_form-control" type="text" formControlName="firstName" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.controls['firstName'].hasError('maxlength')">First Name has a maximum length of {{searchForm.controls['firstName'].errors.maxlength.requiredLength}} characters</div>
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label for="middleNameInput">Middle Name</label>
                    <input id="middleNameInput" class="mvd_form-control" type="text" accesskey="m" formControlName="middleName" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.controls['middleName'].hasError('maxlength')">Middle Name has a maximum length of {{searchForm.controls['middleName'].errors.maxlength.requiredLength}} characters</div>
                    </div>
                </div>
                <div class="col-sm-3 col-md-4 mvd_form-group">
                    <label class="required--multi" title="~ At least one is required" for="lastNameInput">Last Name </label>
                    <input id="lastNameInput" class="mvd_form-control" type="text" formControlName="lastName" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.controls['lastName'].hasError('maxlength')">Last Name has a maximum length of {{searchForm.controls['lastName'].errors.maxlength.requiredLength}} characters</div>
                        <div class="mvd_alert__rule" *ngIf="(searchForm.controls['lastName'].touched || searchForm.controls['customerIdentificationValue'].touched) && searchForm.hasError('lastNameOrIdNumberRequired')">Last Name or {{customerIdentificationType()}} is required</div>
                    </div>
                </div>
                <div class="col-sm-3 col-md-2 mvd_form-group">
                    <label for="dateOfBirthInput">Date of Birth</label>
                    <p-calendar [showIcon]="true" formControlName="dateOfBirth"></p-calendar>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-2 mvd_form-group">
                    <label for="zipcodeInput">ZIP Code</label>
                    <input id="zipcodeInput" class="mvd_form-control" type="text" formControlName="postalZipCode" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.controls['postalZipCode'].hasError('maxlength')">ZIP Code has a maximum length of {{searchForm.controls['postalZipCode'].errors.maxlength.requiredLength}} characters</div>
                    </div>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label for="cityInput">City</label>
                    <input id="cityInput" class="mvd_form-control" type="text" formControlName="city" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.controls['city'].hasError('maxlength')">City has a maximum length of {{searchForm.controls['city'].errors.maxlength.requiredLength}} characters</div>
                    </div>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label for="stateInput">State</label>
                    <select id="stateInput" class="mvd_form-control" formControlName="jurisdictionId">
                        <option [ngValue]="null"></option>
                        <option [ngValue]="state.id" *ngFor="let state of states">{{ state.displayValue }}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.hasError('stateRequired')">State is required</div>
                    </div>
                </div>
                <div class="col-sm-2 mvd_form-group">
                    <label for="countyInput">County</label>
                    <select id="countyInput" class="mvd_form-control" formControlName="countyId">
                        <option [ngValue]="null"></option>
                        <option [ngValue]="county.id" *ngFor="let county of counties">{{ county.displayValue }}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.hasError('countyWrongState')">County is only allowed when State is AZ</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label for="phoneNumberInput">Phone Number</label>
                    <input id="phoneNumberInput" class="mvd_form-control" type="text" placeholder="xxx xxx-xxxx" formControlName="phoneNumber" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.controls['phoneNumber'].hasError('maxlength')">Phone Number has a maximum length of {{searchForm.controls['phoneNumber'].errors.maxlength.requiredLength}} characters</div>
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label for="emailAddressInput">Email Address</label>
                    <input id="emailAddressInput" class="mvd_form-control" type="text" formControlName="emailAddress" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.controls['emailAddress'].hasError('maxlength')">Email Address has a maximum length of {{searchForm.controls['emailAddress'].errors.maxlength.requiredLength}} characters</div>
                    </div>
                </div>
            </div>
        </fieldset>
        <div class="well__footer">
            <div class="btn--group" *ngIf="searchForm.dirty">
                <button class="btn--default" type="button" (click)="reset()">Reset</button>
                <mvm-spinner-btn id="individualCustomerSearchFind" [isDisabled]="!searchForm.valid" [isLoading]="showButtonLoading" [btnText]="'Find'" (clicked)="searchIndividual()"></mvm-spinner-btn>
            </div>
        </div>
    </p-panel>
</form>
<div class="well__footer mvd_form-group" *ngIf="showResults || validationMessage != ''">
    <h2 class="mvd_alert--label">{{validationMessage}}</h2>
    <a class="icon--add" href="javascript:void(0)" (click)="addNewCustomer()" ifSecurityTransaction='["AddCustomer"]'> Add New Customer</a>
</div>